import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal } from '../../actions';

import { getFormattedDateTime } from '../../helpers/DateTime';
import { downloadReasonsEnabled } from '../../helpers/Download';

import Avatar from '../Avatar';

const DownloadsListItem = ({
  profile,
  download,
  handleModal,
}) => {
  const intl = useIntl();

  return (
    <tr>
      <th scope="row">
        <Link to={`/downloads/${download.uuid}`} target="_blank">
          {download.uuid.split('-')[4]}
        </Link>
      </th>
      <td className="download-date">
        {getFormattedDateTime(download.created_at)}
      </td>
      {profile.is_admin && (
        <th scope="row" className="download-user-name">
          {download.user ? (
            <>
              <Avatar user={download.user} />
              {download.user.name}
            </>
          ) : (
            <>
              {download.share_link ? (
                intl.formatMessage({ defaultMessage: 'downloaded from share link' })
              ) : (
                intl.formatMessage({ defaultMessage: 'removed user' })
              )}
            </>
          )}
        </th>
      )}
      <td className="download-files">
        <Link to={`/downloads/${download.uuid}`} target="_blank">
          {download.files}
        </Link>
      </td>
      <td className="action-more">
        <div>
          {download.download_attributes?.image_editor && (
            <>
              <span id={`download-image-editor-${download.uuid}`}>
                <i className="fal fa-crop fa-fw" />
              </span>
              <UncontrolledTooltip target={`download-image-editor-${download.uuid}`} fade={false}>
                {intl.formatMessage({ defaultMessage: 'File downloaded using Image Editor' })}
              </UncontrolledTooltip>
            </>
          )}
          {downloadReasonsEnabled() && download.reason && (
            <>
              <Button
                id={`download-reasons-${download.uuid}`}
                onClick={() => handleModal(download.reason)}
              >
                <i className="fal fa-circle-info fa-fw" />
              </Button>
              <UncontrolledTooltip target={`download-reasons-${download.uuid}`} fade={false}>
                {intl.formatMessage({ defaultMessage: 'Show reason' })}
              </UncontrolledTooltip>
            </>
          )}
          <Link id={`download-${download.uuid}`} to={`/downloads/${download.uuid}`} target="_blank">
            <i className="fal fa-file fa-fw" />
          </Link>
          <UncontrolledTooltip target={`download-${download.uuid}`} fade={false}>
            {intl.formatMessage({ defaultMessage: 'View files' })}
          </UncontrolledTooltip>
        </div>
      </td>
    </tr>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

const mapDispatchToProps = dispatch => ({
  handleModal: (reason) => {
    dispatch(showModal('DownloadReasonsModal', {
      className: 'modal-download-reasons',
      reason,
    }));
  },
});

DownloadsListItem.propTypes = {
  profile: PropTypes.object.isRequired,
  download: PropTypes.object.isRequired,
  handleModal: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadsListItem);
